// src/components/courses/CourseCardDetailed.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './CourseCardDetailed.module.css';

import {
  FaClock, FaLaptopCode, FaCode, FaBrain, FaCloud, FaCheckCircle, FaGlobe, FaRocket, FaPython, FaJava,
  FaClipboardCheck, FaExchangeAlt, FaDatabase, FaCloudUploadAlt, FaAws, FaWindows, FaShieldAlt, FaServer, FaGraduationCap
} from 'react-icons/fa';

const CourseIconMap = {
  FaCode, FaBrain, FaCloud, FaCheckCircle, FaGlobe, FaRocket, FaPython, FaJava, FaClipboardCheck,
  FaExchangeAlt, FaDatabase, FaCloudUploadAlt, FaAws, FaWindows, FaShieldAlt, FaServer, FaGraduationCap
};

const CourseCardDetailed = ({ course, style }) => {
  const MainIconComponent = CourseIconMap[course.icon] || CourseIconMap.FaGraduationCap;

  return (
    <div className={styles.courseCard} style={style}>
      {/* {course.isTrending && <span className={styles.trendingBadge}>Trending 🔥</span>} */}

      {/* NEW: Flex container for the header to align icon and title */}
      <div className={styles.cardHeader}>
        <div className={styles.courseIconWrapper}>
          <MainIconComponent className={styles.courseMainIcon} />
        </div>
        <h3 className={styles.courseTitle}>{course.title}</h3>
      </div>
      
      {/* NEW: Horizontal line below the header */}
      <hr className={styles.headerDivider} />

      {/* You mentioned commenting out these, so they are not rendered */}
      {/* <p className={styles.shortDescription}>{course.shortDescription}</p> */}
      <div className={styles.detailsMeta}>
        <span><FaClock /> {course.duration}</span>
        <span><FaLaptopCode /> {course.delivery}</span>
      </div>

      <div className={styles.featuresList}>
        <h4>Key Highlights:</h4>
        <div className={styles.featuresli}>
           <ul>
          {course.features.slice(0, 3).map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
          {course.features.length > 3 && <li>...and more!</li>}
        </ul>
        </div>
       
      </div>

      <div className={styles.cardFooter}>
        <Link to={`/courses/${course.id}`} className={styles.ctaButton}>
          Learn More
        </Link>
      </div>
    </div>
  );
};

export default CourseCardDetailed;